import { createRequestActions } from "common/helpers/action";

export const initCorrectionList = createRequestActions("KKM.CORRECTION_LIST.INIT");
export const scrollCorrectionList = createRequestActions("KKM.CORRECTION_LIST.SCROLL");
export const searchCorrectionList = createRequestActions("KKM.CORRECTION_LIST.SEARCH");
export const filterCorrectionList = createRequestActions("KKM.CORRECTION_LIST.FILTER");
export const sortCorrectionList = createRequestActions("KKM.CORRECTION_LIST.SORT");

export const showDetailCorrectionList = createRequestActions("KKM.TRANSACTION_LIST.SHOW_DETAIL");
